export type ActionPriority = 'H' | 'M' | 'L';

/**
 * AIAG-VDA 2019 Action Priority (AP) Lookup Table (Simplified)
 * Based on Severity (S), Occurrence (O), and Detection (D)
 */
const getPriorityS9to10 = (O: number, D: number): ActionPriority => {
    if (O >= 6) return 'H';
    if (O >= 4) return D <= 4 ? 'M' : 'H';
    if (O >= 2) return D <= 1 ? 'L' : 'M';
    return 'L';
};

const getPriorityS7to8 = (O: number, D: number): ActionPriority => {
    if (O >= 6) return 'H';
    if (O >= 4) return D <= 4 ? 'M' : 'H';
    if (O >= 2) return D <= 4 ? 'L' : 'M';
    return 'L';
};

const getPriorityS4to6 = (O: number, D: number): ActionPriority => {
    if (O >= 8) return 'H';
    if (O >= 6) return D <= 4 ? 'M' : 'H';
    if (O >= 4) return D <= 4 ? 'L' : 'M';
    return 'L';
};

const getPriorityS1to3 = (O: number, D: number): ActionPriority => {
    if (O >= 8) return 'M';
    if (O >= 6) return D <= 4 ? 'L' : 'M';
    return 'L';
};

/**
 * AIAG-VDA 2019 Action Priority (AP) Lookup Table (Simplified)
 * Based on Severity (S), Occurrence (O), and Detection (D)
 */
export const calculateActionPriority = (S: number, O: number, D: number): ActionPriority => {
    if (S >= 9) return getPriorityS9to10(O, D);
    if (S >= 7) return getPriorityS7to8(O, D);
    if (S >= 4) return getPriorityS4to6(O, D);
    if (S >= 1) return getPriorityS1to3(O, D);
    return 'L';
};

/**
 * Standard RPN Calculation for AIAG V4
 */
export const calculateRPN = (S: number, O: number, D: number): number => {
    return (S || 0) * (O || 0) * (D || 0);
};

/**
 * Risk Class for UI (Background Colors)
 */
export const getRiskLevel = (standard: string, S: number, O: number, D: number): 'critical' | 'high' | 'medium' | 'low' => {
    if (S >= 9) return 'critical';

    if (standard === 'AIAG_VDA') {
        const ap = calculateActionPriority(S, O, D);
        if (ap === 'H') return 'high';
        if (ap === 'M') return 'medium';
        return 'low';
    } else {
        const rpn = calculateRPN(S, O, D);
        if (rpn >= 120) return 'high';
        if (rpn >= 70) return 'medium';
        return 'low';
    }
};
